import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { BreadcrumbModule } from 'primeng/breadcrumb';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { ScrollPanelModule } from 'primeng/scrollpanel';
import { ToastModule } from 'primeng/toast';
import { AuthModule } from '../auth/auth.module';
import { BreadcrumbComponent } from './breadcrumb.component';
import { ApplicationsMenuComponent } from './components/applications-menu.component';
import { AppProfileComponent } from './components/inline-profile.component';
import { ProfileMenuComponent } from './components/profile-menu.component';
import { LayoutTemplateDirective } from './layout-template.directive';
import { LayoutComponent } from './layout.component';
import { LoaderComponent } from './loader/loader.component';
import { LoaderInterceptor } from './loader/loader.interceptor';
import { AppMenuComponent, AppSubMenuComponent } from './menu.component';
import { TopbarComponent } from './topbar.component';

@NgModule({
  imports: [
    CommonModule,
    BreadcrumbModule,
    ScrollPanelModule,
    ToastModule,
    ProgressSpinnerModule,
    AuthModule
],
  exports: [
    LayoutComponent,
    LayoutTemplateDirective
  ],
  declarations: [
    AppMenuComponent,
    AppSubMenuComponent,
    AppProfileComponent,
    ProfileMenuComponent,
    TopbarComponent,
    BreadcrumbComponent,
    ApplicationsMenuComponent,
    LayoutComponent,
    LayoutTemplateDirective,
    LoaderComponent],
  providers: [{
    provide: HTTP_INTERCEPTORS,
    useClass: LoaderInterceptor,
    multi: true
  }],
})
export class LayoutModule { }
